import React from 'react';

const NotFound = () => {
  return <div className="not_found_page">404 Not Found</div>;
};

export default NotFound;
